module.exports = __webpack_public_path__ + "img/reismehltaschengarnelen.284656f7.jpg";